import { render } from "./App.vue?vue&type=template&id=48f01dea"
const script = {}

import "./App.vue?vue&type=style&index=0&id=48f01dea&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__